import Lottie from "react-lottie";
import styled from "styled-components";

const LoginAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: require("../../Animations/login.json"),
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <LodingStyled>
      <div className="loading-center">
        <Lottie options={defaultOptions} className="loading" />
      </div>
    </LodingStyled>
  );
};

const LodingStyled = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  overflow: hidden;

  .loading-center {
    width: 650px;
    place-self: center;
    overflow: hidden;
    object-fit: cover;
  }

  .loading {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: transparent;
  }
`;

export default LoginAnimation;
